export default __webpack_public_path__ + "static/media/016-wall-clock.c3024ce6.svg";